@use "../../../sass/variables/colors" as colors;
@use "../../../sass/mixins/font-family" as typography;
@use "../../../sass/mixins/nimbus" as nimbus;

ux-iws-nb-all-in-one-detail-group {
    --background-color: #{colors.$color-blue-headline};
    --heading-color: #{colors.$color-white};
    --text-color: #{colors.$color-white};
    --ux-button-text-color: #{colors.$color-white};
    --ux-button-bg-color: transparent;
    --ux-button-border-color: #{colors.$color-white};
    --ux-button-hover-border-color: #{colors.$color-white};
}

ux-iws-nb-all-in-one-detail-group {
    @include typography.font(light);
    @include nimbus.nb-cta-blue-background();
    display: block;
    box-sizing: border-box;
    background-color: var(--background-color);
    color: var(--text-color);
    width: 100%;
    height: 0;
    overflow: hidden;
    transition: height 0.3s ease-out;

    .ux-iws-nb-all-in-one-detail-group__button,
    .ux-iws-nb-all-in-one-detail-group__dropdown {
        min-width: 250px;
    }

    .ux-iws-nb-all-in-one-detail-group__dropdown {
        color: colors.$color-blue-headline;

        @media (max-width: 567px) {
            width: 100%;
        }

        @media (min-width: 768px) {
            display: none;
        }
    }
}

ux-iws-nb-all-in-one-detail-group[active] {
    height: auto;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);

    .ux-iws-nb-all-in-one-detail-group__inner {
        opacity: 1;
        transition: opacity 0.5s ease-in-out 0.1s;
    }
}

.ux-iws-nb-all-in-one-detail-group {
    &__inner {
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
    }

    &__items {
        flex: 1 1 auto;
    }

    &__navigation {
        display: block;
        padding: 15px;

        @media (min-width: 768px) {
            padding: 30px;
        }

        @media (min-width: 1024px) {
            padding: 30px 60px;
        }
    }

    &__buttons {
        display: flex;
        flex-flow: row wrap;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 10px;

        @media (max-width: 767px) {
            display: none;
        }
    }
}
